import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: "empty-state",
	templateUrl: "./empty-state.component.html",
	styleUrls: ["./empty-state.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class EmptyStateComponent {
	@Input() icon: string;
	@Input() message: string;
}
